import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: {
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 600,
    } as SxProps<Theme>,
};
